import React, { Fragment } from "react";
import "./user-team.css";

const UserTeam = ({ image, name, job, desc1, desc2 }) => {
  return (
    <Fragment>
      <div className="user_team_body">
        <div>
          <img src={image} className="user_team_image" />
        </div>
        <div className="user_team_name">{name}</div>
        <div className="user_team_jobtitle">{job}</div>
        <div style={{ marginBottom: "10px" }} className="user_team_desc">
          {desc1}
        </div>
        <div className="user_team_desc">{desc2}</div>
      </div>
    </Fragment>
  );
};

export default UserTeam;
